import 'default-passive-events';
import 'font-awesome/css/font-awesome.css';
import Vue from "vue";
import i18n from "@/i18n";
import '@/plugins/vuetify'
import App from "@/App.vue";
import router from "@/router";
import store from "@/store";
import "@/components/monaco/PermissionUtils";
import 'roboto-fontface/css/roboto/roboto-fontface.css';
import "mapbox-gl/dist/mapbox-gl.css";
import axios from 'axios';
import api from '@/constants/api';
import moment from 'moment';
import titleMixin from '@/mixins/titleMixin';
import { ChartPlugin } from "@syncfusion/ej2-vue-charts";
import * as VueGoogleMaps from 'vue2-google-maps'
import VuejsDialog from 'vuejs-dialog';
import 'vuejs-dialog/dist/vuejs-dialog.min.css';
import Dialova from '@/plugins/dialova.js';
import ComplaintDialog from '@/plugins/complaint_dialog.js';
import VueTippy, { TippyComponent } from "vue-tippy";
import VueMask from "v-mask";
import './registerServiceWorker';
import formatDateMixin from "@/mixins/formatDate";

Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyDhGRYnKsOG3EFx4IhSD0HLm1cQUmYYp2c',
        libraries: 'places',
    },
});

Vue.use(Dialova);
Vue.use(ComplaintDialog);
Vue.use(VueMask);
Vue.component("tippy", TippyComponent);
Vue.config.productionTip = false;
axios.defaults.timeout = 1000 * 300;
axios.defaults.baseURL = api.MAIN_URL + '/api/';

// const circularStringify = function (v) {
//   const cache = new Set();
//   return JSON.stringify(v, function (key, value) {
//     if (typeof value === 'object' && value !== null) {
//       if (cache.has(value)) {
//         // Circular reference found, discard key
//         return;
//       }
//       // Store value in our set
//       cache.add(value);
//     }
//     return value;
// 	}, 2);
// };

// const clamp = (num, min, max) => Math.min(Math.max(num, min), max);

Vue.prototype.axios = axios;
Vue.prototype.api = api;
Vue.prototype.moment = moment;
// window.circularStringify = circularStringify;
window.moment = moment;
// window.clamp = clamp;
Vue.use(ChartPlugin);
Vue.use(VuejsDialog);
Vue.mixin(titleMixin);
Vue.mixin(formatDateMixin);

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app');
